import { render, staticRenderFns } from "./Collapse.vue?vue&type=template&id=121bcc06&"
import script from "./Collapse.vue?vue&type=script&lang=ts&"
export * from "./Collapse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports